export const AppError = "core.AppError"
export interface AppError {
    message?: string
    exception?: any
    stackTrace?: any
    extraInfo?: any
}
